const initialState = {
  featureFlags: (typeof window !== 'undefined' && window.config && window.config.featureFlags) || [],
}

export default function features(state = initialState, action) {
  switch (action.type) {
    default:
      return state
  }
}